module.exports = __webpack_public_path__ + "static/img/logo-default.2c456f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/common/logo-default.png
// module id = L1s0
// module chunks = 1